const PagesHeader = ({ cssHeader = "", child = null }) => {
  const headerCss = `h-[14vh] w-full global-px mb-2 pt-2 bg-darkOrange flexJustifyItemsCenter text-white text-center shadow-md shadow-darkOrange ${cssHeader}`;

  return (
    <header className={headerCss}>
      {child ? child : <div>Un header vide</div>}
    </header>
  );
};

export default PagesHeader